import { Injectable, inject } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { catchError, Observable, throwError } from 'rxjs'
import { ToastrService } from 'ngx-toastr'
import { Router } from '@angular/router'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private toastr = inject(ToastrService);
    private router = inject(Router);


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                this.showError(error)
                return throwError(() => error)
            })
        )
    }

    private showError(httpErrorResponse: HttpErrorResponse) {
        this.redirectOnErrorPage(httpErrorResponse)
        this.showErrorToast(httpErrorResponse)
    }

    private redirectOnErrorPage(httpErrorResponse: HttpErrorResponse) {
        if (httpErrorResponse.status === 404) {
            void this.router.navigate(['/not-found'], { skipLocationChange: true })
        }
    }

    private showErrorToast(httpErrorResponse: HttpErrorResponse) {
        let message: string = httpErrorResponse.error?.message
        let title: string = httpErrorResponse.error?.title

        message = message ? message : httpErrorResponse.error
        title = title ? title : `Erreur ${httpErrorResponse.status}`

        this.toastr.error(message, title)
    }
}
